import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { NekoTypo } from '../misc/Typography';
import NekoBusyOverlay from '../common/NekoBusyOverlay';
import { useClasses } from '../hooks';

const Block = Styled.div`
  font-size: ${Theme.fontSizeText};
  margin-bottom: 15px;

  .neko-block-header {
    display: flex;
    justify-content: space-between;
  }

  .neko-block-title {
    padding: 5px 10px;
    margin-bottom: 5px;
  }

  .neko-block-content {
    background: var(--content-background);
    color: var(--content-font-color);
    padding: 15px 15px;
    box-shadow: 0px 2px 5px 0px #0000004a;
    border-radius: 10px;

    p:first-child {
      margin-top: 0;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }

  &.primary {
    padding: 8px;
    background-color: var(--block-background);
    color: var(--block-font-color);

    .neko-block-title {
      color: var(--block-font-color);
    }

    .neko-block-content {
      background-color: var(--content-background);
    }
  }

  &.standard {
    .neko-block-content {
      box-shadow: none;
    }
  }
`;

/**
 * @oaram {string} className
 */
const StyledNekoBlock = props => {

  const { title, children, className, busy = false, style = {}, contentStyle = {}, action } = props;
  const classNames = useClasses('neko-block', className);

  return (
      <Block className={classNames} style={style}>
        <NekoBusyOverlay busy={busy}>
          <div className="neko-block-header">
            <NekoTypo h2 className="neko-block-title">{title}</NekoTypo>
            {!!action && action}
          </div>
          <div className="neko-block-content" style={contentStyle}>
            {children}
          </div>
        </NekoBusyOverlay>
      </Block>
  );
};

const NekoBlock = (props) => {
  return (<StyledNekoBlock {...props} />);
}

NekoBlock.propTypes = {
  title: PropTypes.string,
  className: PropTypes.oneOf(['', 'primary', 'standard']),
  style: PropTypes.object,
  action: PropTypes.element,
};

NekoBlock.defaultProps = {
  title: undefined,
  className: '',
  style: {},
  action: undefined,
};

export { NekoBlock };
